const INPUTS_SELECTOR = 'input, textarea';

export { INPUTS_SELECTOR };
